<template>
  <list-cell :items="attachments" type="bullet" class="uk-margin-remove">
    <template slot="item" scope="document">
      <a :href="document.item.url" target="_blank">
        <attachment-name :attachment="document.item" />
      </a>
    </template>
  </list-cell>
</template>

<script>
import AttachmentName from '@/components/AttachmentName';
import ListCell from '@/components/ListCell';

export default {
  name: 'documents-cell',
  components: {
    AttachmentName,
    ListCell,
  },
  props: {
    attachments: {
      type: Array,
      default: () => [],
    },
  },
};
</script>



// WEBPACK FOOTER //
// DocumentsCell.vue?2ddea63c